import axios from "axios";

export const subjectColors = {
  maths: {
    hex1: "#fb8b23",
    hex2: "#ffdd00",
  },
  physics: {
    hex1: "#ed82c1",
    hex2: "#f9c6d7",
  },
  chemistry: {
    hex1: "#ff571f",
    hex2: "#ff8a5c",
  },
  biology: {
    hex1: "#0ac2a6",
    hex2: "#51f6f0",
  },
  history: {
    hex1: "#999cff",
    hex2: "#99c3ff",
  },
  civics: {
    hex1: "#85c445",
    hex2: "#c3db9f",
  },
  geography: {
    hex1: "#ff7f5c",
    hex2: "#ffc5ad",
  },
  economics: {
    hex1: "#efbd81",
    hex2: "#f6e8a2",
  },
  literature: {
    hex1: "#ff4b33",
    hex2: "#f78978",
  },
  "beehive chapters": {
    hex1: "#ff4b33",
    hex2: "#f78978",
  },
  "beehive poems": {
    hex1: "#ff4b33",
    hex2: "#f78978",
  },
  moments: {
    hex1: "#ff4b33",
    hex2: "#f78978",
  },
  writing: {
    hex1: "#00b899",
    hex2: "#58e0bb",
  },
  grammar: {
    hex1: "#de85ff",
    hex2: "#f3c2ff",
  },
  reading: {
    hex1: "#e9275b",
    hex2: "#f07f8c",
  },
};

export async function getVimeoURL(video_id) {
  const response = await axios.get('https://api.vimeo.com/videos/' + video_id, {
    headers: {
      "Authorization": "Bearer eb3aa30f683094b5e51d077a9b8bbff5"
    }
  });

  console.log('response - ', response, response.data.link);

  return {
    url: response.data.link,
  };
}
